<template>
  <nav class="main_nav">
    <div class="main_nav-inner">
      <router-link to="/" >
        <img width="340" height="60" src="../assets/img/common/site_title_noyear.svg" alt="Recruiting Kureha" />
      </router-link>
      <div>
        <router-link to="/" class="redirect-top">
          <span>クレハ採用サイトTOP</span>
          <img src="../assets/img/common/circle-arrow-right.svg"  alt=""/>
        </router-link>
      </div>
      <MyNav />
      <!--  Footer   -->
      <ul class="main_nav__footer">
        <li>
          <a href="https://www.kureha.co.jp/" target="_blank">
            クレハ オフィシャルHP
            <IconBase :width="12" iconColor="#000000" class="icon_base"
            ><Blank
            /></IconBase>
          </a>
        </li>
        <li>
          <a href="https://www.kureha.co.jp/policies/" target="_blank">
            プライバシーポリシー
            <IconBase :width="12" iconColor="#000000" class="icon_base"
            ><Blank
            /></IconBase>
          </a>
        </li>
        <li>
          <a href="https://www.kureha.co.jp/terms/" target="_blank">
            サイト利用にあたって
            <IconBase :width="12" iconColor="#000000" class="icon_base"
            ><Blank
            /></IconBase>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import IconBase from '@/components/IconBase.vue';
import Blank from '@/components/icons/Blank.vue';
import MyNav from "@/components/MyNav.vue";
export default {
  name: 'MainNav',
  components: {
    MyNav,
    IconBase,
    Blank,
  },
};
</script>

<style scoped lang="scss">

@mixin menu-styled{
  ul {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    @media print, screen and (max-width: 900px){
      row-gap: 24px;
    }
    & > li {
      max-width: fit-content;

      & > a{
        font-size: 16px;
        line-height: 32px;
        font-weight: 700;
        color: #000000;
        @media print, screen and (max-width: 900px){
          display: flex;
          align-items: center;
          justify-content: flex-start;
          & > span{
            &:last-child{
              font-size: 14px;
              margin-left: 12px;
            }
          }
        }
        & > span {
          font-size: 12px;
          display: block;
          line-height: normal;
        }
      }
    }
  }
}

@mixin border-dash{
  border-left: 1px dashed #CCCCCC;
  border-right: 1px dashed #CCCCCC;
}

.redirect-top{
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3C3C3C ;
  border-radius: 4px;
  border: 2px solid #3C3C3C;
  font-weight: 700;
  background-color: white;
  max-width: 291px;
  margin: 24px auto;
  box-sizing: border-box;

  & > img {
    display: none;
  }
  @media print, screen and (max-width: 900px){
    max-width: 100%;
    justify-content: space-between;
    padding: 0 14px;
    margin: 54px auto 50px auto;

    & > img {
      display: block;
    }
  }

}

.main_nav {
  width: 100%;
  background-color: #F9F9F9;
  margin-top: -100vh;
  position: fixed;
  z-index: 90;
  transition: margin-top 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  overflow-y: scroll;
  height: 100svh;
  max-height: calc(100% - 50px);
  &.open {
    margin-top: 50px;
    top: 0;
  }

  &__footer{
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 44px;
    box-sizing: border-box;
    @media print, screen and (max-width: 900px){
      padding: 0 24px;
      align-items: flex-start;
      flex-direction: column;
      row-gap: 28px;
      margin-top: 68px;
    }
    & > li {
      & > a {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 12px;
        font-size: 15px;
        font-weight: 700;
        color: black;
        @media print, screen and (max-width: 900px){
          font-size: 16px;
          column-gap: 12px;

          & > svg{
            @media print, screen and (max-width: 900px){
              width: 10px;
            }
          }
        }
      }
    }
  }
}
.main_nav-inner {
  max-width: 1105px;
  width: 100%;
  margin: 30px auto 50px;
  @media print, screen and (max-width: 900px){
    max-width: 480px;
  }
  & > a{
    &:first-child{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      max-width: fit-content;
      margin: 78px auto 57px auto;
      @media print, screen and (max-width: 900px){
        display: none;
      }
    }
  }

  & > div{
    padding: 0 24px;
  }
}
</style>
